import { render, staticRenderFns } from "./DrowningView.vue?vue&type=template&id=50005400&scoped=true"
import script from "./DrowningView.vue?vue&type=script&lang=js"
export * from "./DrowningView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50005400",
  null
  
)

export default component.exports